export default "__VITE_ASSET__DzAqc62T__"